import React from "react";

export const DOC_STATUS = {
  draft: ["Draft", "bg-[#F1F1F6] text-[#595D62]"],
  in_review: ["In review", "bg-sky-50 text-sky-700"],
  with_client: ["With client", "bg-[#EDE7FF] text-[#5b2fd6]"],
  feedback: ["Feedback received", "bg-amber-50 text-amber-800"],
  approved: ["Approved", "bg-emerald-50 text-emerald-700"],
  published: ["Published", "bg-emerald-600 text-white"],
};

export const DocStatusPill = ({ status }) => {
  const [l, c] = DOC_STATUS[status] || DOC_STATUS.draft;
  return <span data-testid="doc-status" className={`font-mono-data text-[10px] uppercase tracking-wide rounded-full px-2 py-0.5 ${c}`}>{l}</span>;
};

export const fmtWhen = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date().toDateString() === d.toDateString();
  return today ? d.toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" }) : d.toLocaleString("en-AU", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
};
